/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      cognitoID
      name
      mail
      phone
      pass
      role
      comName
      comAddress
      comUnit
      comMail
      comPhone
      gate
      pSpot
      pNumber
      pNumGuest
      pAdmin
      pHandcap
      pSystem
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      cognitoID
      name
      mail
      phone
      pass
      role
      comName
      comAddress
      comUnit
      comMail
      comPhone
      gate
      pSpot
      pNumber
      pNumGuest
      pAdmin
      pHandcap
      pSystem
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      cognitoID
      name
      mail
      phone
      pass
      role
      comName
      comAddress
      comUnit
      comMail
      comPhone
      gate
      pSpot
      pNumber
      pNumGuest
      pAdmin
      pHandcap
      pSystem
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTenant = /* GraphQL */ `
  mutation CreateTenant(
    $input: CreateTenantInput!
    $condition: ModelTenantConditionInput
  ) {
    createTenant(input: $input, condition: $condition) {
      id
      name
      email
      carMake
      carModel
      licensePlate
      carMake2
      carModel2
      licensePlate2
      Apartment
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTenant = /* GraphQL */ `
  mutation UpdateTenant(
    $input: UpdateTenantInput!
    $condition: ModelTenantConditionInput
  ) {
    updateTenant(input: $input, condition: $condition) {
      id
      name
      email
      carMake
      carModel
      licensePlate
      carMake2
      carModel2
      licensePlate2
      Apartment
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTenant = /* GraphQL */ `
  mutation DeleteTenant(
    $input: DeleteTenantInput!
    $condition: ModelTenantConditionInput
  ) {
    deleteTenant(input: $input, condition: $condition) {
      id
      name
      email
      carMake
      carModel
      licensePlate
      carMake2
      carModel2
      licensePlate2
      Apartment
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createGuest = /* GraphQL */ `
  mutation CreateGuest(
    $input: CreateGuestInput!
    $condition: ModelGuestConditionInput
  ) {
    createGuest(input: $input, condition: $condition) {
      id
      name
      email
      carMake
      carModel
      licensePlate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateGuest = /* GraphQL */ `
  mutation UpdateGuest(
    $input: UpdateGuestInput!
    $condition: ModelGuestConditionInput
  ) {
    updateGuest(input: $input, condition: $condition) {
      id
      name
      email
      carMake
      carModel
      licensePlate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteGuest = /* GraphQL */ `
  mutation DeleteGuest(
    $input: DeleteGuestInput!
    $condition: ModelGuestConditionInput
  ) {
    deleteGuest(input: $input, condition: $condition) {
      id
      name
      email
      carMake
      carModel
      licensePlate
      createdAt
      updatedAt
      __typename
    }
  }
`;
